import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../firebase";
import Config from "../../core/config";
import { makeRequest } from "../../core/services/v1/request";
import CryptoJS from 'crypto-js';
const SECRET_KEY = Config.ENCKEY;

export const handleGoogleSignIn = async (type = '') => {
    try {
        if (type !== 'register-web' && type !== 'login') {
            throw new Error('Invalid type for Google SignIn');
        }
        const result = await signInWithPopup(auth, googleProvider);
        const idToken = await result.user.getIdToken(true);
        let isNewUser = false;
        isNewUser = result._tokenResponse?.isNewUser || false;
        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify({ idToken, isNewUser, provider: 'google' }),
            SECRET_KEY,
        ).toString()
        const params = {
            url: `${Config.V1_API_URL}user/${type}`,
            method: 'POST',
            data: { data: encryptedData },
        }
        const sendAuhthData = await makeRequest(params)
        return sendAuhthData;
    }
    catch (error) {
        console.error('Google Sign-In Error:', error);
        throw error;
    }
};
